import React, { FC } from 'react';
import styled from 'styled-components';
import { COLORS } from 'components/twilio/constants';
import generateMessageId from 'components/twilio/utils/generateMessageId';

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 8px 0;
`;

const SystemMessageContainer = styled.div`
  max-width: 75%;
  padding: 4px 8px;
  font-size: 14px;
  text-align: center;
  background-color: rgba(211, 211, 211, 0.5);
  color: ${COLORS.TEXT_DARK};
  border-radius: 4px;
`;

export interface SystemMessageProps {
  index: number;
  content: string;
}

const SystemMessage: FC<SystemMessageProps> = ({ index, content }) => (
  <RootContainer id={generateMessageId(index)}>
    <SystemMessageContainer>
      {content}
    </SystemMessageContainer>
  </RootContainer>
);

export default React.memo(SystemMessage);
